import { Button, Table, message } from 'antd'
import React, { useEffect, useState } from 'react'
import { Outlet } from "react-router-dom";
import Filter from './../../../components/Filter';
import { useSelector } from 'react-redux';
import axios from 'axios';
function PharmaciesAdminsList() {
  const API_URL = import.meta.env.VITE_API_URL;
  const accessToken = useSelector((state) => state.user.accessToken);
  const [adminList, setAdminList] = useState();
  const [pharmacies, setPharmacies] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({ pharmacyId: null, status: null, search: null });
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [filterDropdowns, setFilterDropdowns] = useState([
    {
      title: "Pharmacy",
      options: [],
    },
    {
      title: "Status",
      options: [],
    }

  ]);
  const fetchAdmin = async (page = 1, pageSize = 10, pharmacyId = null, search = null, active = null) => {
    setLoading(true);
    try {
      let apiUrl;
      let response;

      // Fetch all pharmacies without pagination
      const allPharmaciesResponse = await axios.get(`${API_URL}pharmacies/get-pharmacies?limit=1000`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      const allPharmacies = allPharmaciesResponse.data.Pharmacies.map(pharmacy => ({
        id: pharmacy.id,
        name: pharmacy.name,
      }));
      setPharmacies(allPharmacies);
      setFilterDropdowns([
        { title: "Pharmacy", options: allPharmacies.map(pharmacy => pharmacy.name) },
        { title: "Status", options: ['Active', 'Inactive'] },
      ]);

      // Determine API URL based on pharmacyId
      if (pharmacyId) {
        // Fetch specific pharmacy by ID
        apiUrl = `${API_URL}pharmacies?id=${pharmacyId}`;
        response = await axios.get(apiUrl, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });

        // Normalize response to ensure it's always an array
        const pharmacyData = response.data.Pharmacy
          ? [response.data.Pharmacy] // Wrap single object in an array
          : response.data.Pharmacies || []; // Default to array if Pharmacies exists

        console.log("pharmacyData", pharmacyData);

        // Extract admin details
        const adminList = pharmacyData.map((pharmacy, index) => ({
          id: pharmacy.adminDetails?.id || `temp-${index}`,
          contactNumber: pharmacy.contactNumber || null,
          active: pharmacy.adminDetails?.active || false,
          firstName: pharmacy.adminDetails?.userDetails?.firstName || '',
          lastName: pharmacy.adminDetails?.userDetails?.lastName || '',
          pharmacyName: pharmacy.name || '',

        }));

        setAdminList(adminList);

        // Update pagination for single item
        setPagination(prev => ({
          ...prev,
          current: page,
          pageSize: pageSize,
          total: pharmacyData.length, // Ensure correct total count
        }));

      } else {
        // Fetch pharmacies with pagination
        const queryParams = new URLSearchParams({
          limit: pageSize,
          page: page,
          ...(active !== null && { active }),
          ...(search && { search }),
        }).toString();

        apiUrl = `${API_URL}users/get-users?role[]=4&${queryParams}`;
        response = await axios.get(apiUrl, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        // Extract admin details
        const adminList = response.data.users.map((pharmacy, index) => ({
          id: pharmacy?.id || `temp-${index}`,
          contactNumber: pharmacy.mobileNumber || null,
          active: pharmacy?.active || false,
          firstName: pharmacy?.userDetails?.firstName || '',
          lastName: pharmacy?.userDetails?.lastName || '',
          pharmacyName: pharmacy.pharmacyDetails?.name || '',
        }));

        setAdminList(adminList);

        // Update pagination
        setPagination(prev => ({
          ...prev,
          current: page,
          pageSize: pageSize,
          total: response.data.totalCount,
        }));
      }

    } catch (error) {
      console.error("Error fetching admins:", error);
      message.error("Failed to fetch admins");
    } finally {
      setLoading(false);
    }
  };
  const handleFilterChange = (key, value) => {
    let updatedFilters = { ...selectedFilters };
    let errorMessageShown = false;

    if (key === "Pharmacy") {
      const pharmacyId = value ? pharmacies.find(ph => ph.name === value)?.id : null;
      updatedFilters.pharmacyId = pharmacyId;
    }

    if (key === "Status") {
      updatedFilters.status = value === "Active" ? 1 : value === "Inactive" ? 0 : null;
    }

    if (key === "search") {
      let search = null;

      if (value && value.trim().length > 0) {
        const searchValue = parseInt(value, 10);

        if (isNaN(searchValue)) {
          message.destroy();
          message.error("Search term must be a valid number.");
          errorMessageShown = true;
        } else if (value.length > 4) {
          search = searchValue;
        }
      }

      updatedFilters.search = search;
    }

    if (key === "") {
      fetchAdmin();
      updatedFilters = {};
    }

    setSelectedFilters(updatedFilters);
    fetchAdmin(1, pagination.pageSize, updatedFilters.pharmacyId, updatedFilters.search, updatedFilters.status);
  };
  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchAdmin(pagination.current, pagination.pageSize, selectedFilters.pharmacyId, selectedFilters.search, selectedFilters.status);
  };

  useEffect(() => {
    fetchAdmin();
  }, [])

  const handleStatusChange = async (id, isActive) => {
    const status = isActive ? 1 : 0;
    try {
      const response = await axios.patch(`${API_URL}Users/?id=${id}`, { active: status },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.status === 200) {
        message.success("Status updated successfully");
        fetchAdmin()
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const columns = [
    {
      title: <span>Admin Name</span>,
      dataIndex: "",
      key: "AdminName",
      render: (userDetails) => {
        const firstName = userDetails?.firstName || '';
        const lastName = userDetails?.lastName || '';
        return (firstName || lastName) ? `${firstName} ${lastName}` : '';
      },
    },
    {
      title: "Pharmacy",
      dataIndex: "pharmacyName",
      key: "pharmacyName",
    },
    {
      title: "Contact",
      dataIndex: "contactNumber",
      key: "Contact",
    },

    {
      title: "Status",
      dataIndex: "active",
      render: (text, row) => (

        <div className="flex">
          <Button
            disabled={row.active}
            style={{
              borderRadius: 0,
              border: 0,
              margin: 0,
              backgroundColor: row.active ? "#3371EB" : "#F7F8FF",
              color: row.active ? "#FFFFFF" : "#123288",
              cursor: row.active ? "not-allowed" : "pointer",
            }}
            onClick={() => handleStatusChange(row.id, true, row.mobileNumber)} // Active button click
          >
            Active
          </Button>
          <Button
            disabled={!row.active}
            style={{
              borderRadius: 0,
              margin: 0,
              border: 0,
              backgroundColor: row.active ? "#F7F8FF" : "#3371EB",
              color: row.active ? "#123288" : "#FFFFFF",
              cursor: !row.active ? "not-allowed" : "pointer",
            }}
            onClick={() => handleStatusChange(row.id, false)} // Inactive button click
          >
            Inactive
          </Button>
        </div>
      ),
    },

  ]

  const [filterOptions, setFilterOptions] = useState({})
  return (
    <>
      <div className=' space-y-5 '>
        <Filter
          filterOptions={filterOptions}
          setFilterOptions={setFilterOptions}
          dropdowns={filterDropdowns}
          addItemName=""
          resetFilter={false}
          filterBy={true}
          onFilterChange={handleFilterChange}
          searchBarPlaceholder="Search"
        />
        <div className="table-responsive-wrapper responsive-table-container">
          <Table
            className="customTable"
            columns={columns}
            dataSource={adminList}
            loading={loading}
            rowKey="id"
            pagination={pagination}
            onChange={handleTableChange}
          />
        </div>
      </div >
      <Outlet />
    </>
  )
}

export default PharmaciesAdminsList
